import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {AuthGuard} from '@core/services/auth-guard.service';
import {GemsAnalyticsComponent} from '@features/gems/components/gems-analytics/gems-analytics.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';

export const gemsRoutes: Routes = [
  {
    path: 'gems/entities',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gems/entities/link/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gems/analytics',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gems/history/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path     : 'gems/entities/filters/:magicLinkId',
    component: PlatformToolContainerComponent
  }
];
